import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { getUserData, loginUserWithEmail, updateUser } from 'APIs/AuthApi';
import { postUserData } from 'APIs/UserDataApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { AxiosResponse } from 'axios';
import SignButton from 'components/atoms/Button/SignButton';
import InputText from 'components/molecules/InputText/InputText';
import { ACCESS_TOKEN } from 'constant';
import { login, selectAuth } from 'features/auth/authSlice';
import {
  UserData,
  UserFormData,
  UserPlatform,
} from 'interfaces/UserData.interface';
import { TorusData } from 'interfaces/torus.interface';
import React from 'react';
import { createTatumAccount, getTatumAddress } from '../../../APIs/tatum';
import { ContentGrid, ParaText, TitleText } from './AuthPopup.styles';

interface ISignupForm {
  creatorToken?: string;
  torusData?: TorusData;
}

const SignUpForm = ({ torusData }: ISignupForm) => {
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const emptyFunc = () => {};
  console.log('torusData', torusData?.email);
  const [usernameAvailable, setUsernameAvailable] = React.useState<
    boolean | null
  >(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  const [formData, setFormData] = React.useState<UserFormData>({
    name: '',
    username: '',
    password: '',
    email: torusData?.email || '',
    address: '',
    walletAddress: authState.walletAddress || '',
    torusWalletId: torusData?.torusWalletId || '',
    platform: UserPlatform.CLIENT,
    seenOnBoarding: false,
  });
  const [error, setError] = React.useState<string>('');

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.currentTarget as HTMLInputElement;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let userDataRes: UserData | null = null;
    setError('');
    const form = event.currentTarget as HTMLFormElement;
    if (form.username.value !== form.username1.value) {
      setError('Username is not matching');
      return;
    }

    setLoading(true);

    const data: UserFormData = {
      name: formData.name,
      username: formData.username,
      email: formData.email,
      password: 'accessAll',
      walletAddress: formData.walletAddress,
      torusWalletId: formData.torusWalletId,
      platform: formData.platform,
      address: formData.address,
      seenOnBoarding: formData.seenOnBoarding,
    };

    setUsernameAvailable(null);
    try {
      const res: AxiosResponse<any, any> = await postUserData(
        data,
        window.location.origin
      );
      if (res.status === 201 && data?.torusWalletId) {
        const loginRes = await loginUserWithEmail(
          data.email,
          data.torusWalletId,
          window.location.origin
        );
        if (loginRes.data.access_token) {
          localStorage.setItem(ACCESS_TOKEN, loginRes.data.access_token);
          userDataRes = await getUserData();
          if (userDataRes) {
            dispatch(login({ ...userDataRes }));
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);

    const tatumAccountResponse = await createTatumAccount();
    const tatumAccountData = tatumAccountResponse.data;
    const id = tatumAccountData.id;
    const depositAddressResp = await getTatumAddress(id);
    const tatumDepositAddressData = depositAddressResp.data;
    if (tatumAccountData.id && tatumDepositAddressData.address && userDataRes) {
      await updateUser({
        id: userDataRes.id,
        tatumUserId: tatumAccountData.id,
        tatumWalletAddress: tatumDepositAddressData.address,
      });
    }
  };

  return (
    <>
      <ContentGrid sx={{ paddingTop: '20px' }}>
        <TitleText sx={{ my: { sm: -1, xs: 4 } }}>Sign Up</TitleText>
      </ContentGrid>
      <ContentGrid>
        <ParaText>Welcome to Buku!</ParaText>
      </ContentGrid>
      <form onSubmit={handleFormSubmit}>
        {error && (
          <ParaText
            style={{ color: 'red', textAlign: 'center', paddingBottom: '10px' }}
          >
            {error}
          </ParaText>
        )}

        <ContentGrid style={{ paddingBottom: '20px' }}>
          <InputText
            initValue=""
            placeholder={'Name'}
            type={'user'}
            ablefunction={emptyFunc}
            unablefunction={emptyFunc}
            setName={emptyFunc}
            name={'name'}
            onChange={e => handleInputChange(e)}
          />
        </ContentGrid>
        <ContentGrid style={{ paddingBottom: '30px' }}>
          <InputText
            initValue=""
            placeholder={'Email address'}
            type={'mail'}
            ablefunction={emptyFunc}
            unablefunction={emptyFunc}
            setName={emptyFunc}
            name={'email'}
            disabled={true}
            onChange={e => handleInputChange(e)}
            value={torusData?.email || ''}
          />
        </ContentGrid>
        <ContentGrid style={{ paddingBottom: '20px' }}>
          <InputText
            initValue=""
            placeholder={'Username'}
            type={'user'}
            ablefunction={emptyFunc}
            unablefunction={emptyFunc}
            setName={emptyFunc}
            name={'username'}
            onChange={e => handleInputChange(e)}
            minLength={4}
          />

          {usernameAvailable ? (
            <Box
              style={{
                position: 'absolute',
                display: 'flex',
                right: '60px',
                color: '#3fbf7f',
                fontSize: '14px',
              }}
            >
              <CheckIcon />
              <Typography>available</Typography>
            </Box>
          ) : usernameAvailable === false ? (
            <Box
              style={{
                position: 'absolute',
                display: 'flex',
                right: '60px',
                color: '#bf3f3f',
                fontSize: '14px',
              }}
            >
              <CloseIcon />
              <Typography>already taken</Typography>
            </Box>
          ) : (
            <></>
          )}
        </ContentGrid>
        <ContentGrid style={{ paddingBottom: '20px' }}>
          <Typography
            component={'span'}
            sx={{ color: '#ffffff', fontsize: '16px' }}
          >
            This will be displayed as{' '}
            <span style={{ color: '#36899f' }}>
              buku.gg/{formData.username}
            </span>
          </Typography>
        </ContentGrid>
        <ContentGrid style={{ paddingBottom: '20px' }}>
          <InputText
            initValue=""
            placeholder={'Confirm Username'}
            type={'user'}
            ablefunction={emptyFunc}
            unablefunction={emptyFunc}
            setName={emptyFunc}
            name={'username1'}
            onChange={e => handleInputChange(e)}
            minLength={4}
          />
        </ContentGrid>
        <ContentGrid style={{ paddingBottom: '20px' }}>
          <InputText
            initValue={''}
            placeholder={'Location'}
            type={'address'}
            ablefunction={emptyFunc}
            unablefunction={emptyFunc}
            setName={emptyFunc}
            name={'address'}
            onChange={e => handleInputChange(e)}
          />
        </ContentGrid>
        <ContentGrid
          sx={{
            justifyContent: 'center',
            paddingBottom: '10px',
            paddingX: '80px',
          }}
        >
          <div style={{ width: '100%', padding: '10px' }}>
            <SignButton
              text={'Sign Up'}
              color={'yellow'}
              type="submit"
              disabled={loading}
            />
          </div>
        </ContentGrid>
      </form>
    </>
  );
};

export default SignUpForm;
